import { Component, OnInit } from '@angular/core';
import {Localiser} from "../../services/localiser";
import {contacto} from "../../models/contacto";
import {Navigation} from "../../services/navigation.service";
import {ContactMessageService} from "../../services/contact-message.service";
import {contactoMensaje} from "../../models/contactoMensaje";
import {UserService} from "../../services/user.service";
import {ContactService} from "../../services/contact.service";

@Component({
  selector: 'app-contact-message',
  templateUrl: './contact-message.component.html',
  styleUrls: ['./contact-message.component.css']
})
export class ContactMessageComponent implements OnInit {

  expand: boolean = true;
  contacto: contacto;
  mensaje: string;
  contactoMensajes: contactoMensaje[] = [];
  constructor(public contactMessageService: ContactMessageService, public localiser: Localiser,
              private navigation: Navigation, public user: UserService, private contactService: ContactService) { }

  ngOnInit(): void {
    if (this.contactMessageService.getContacto() == null) {
      this.toAirfal();
    } else {
      this.contacto = this.contactMessageService.getContacto();
      this.getContactosMensajes();
    }
  }

  getContactosMensajes() {
    this.contactMessageService.getByIdContacto(this.contacto.idContacto).subscribe(result => {
      let mensajes = <contactoMensaje[]> result;
      for (let m of mensajes) {
        m.date = new Date(m.date);
        console.log(m.date);
        console.log(m.mensaje);
      }
      mensajes = mensajes.sort((a, b) =>
        a.date.getTime() - b.date.getTime()
      );
      this.contactoMensajes = mensajes;
    });
  }

  toAirfal() {
    this.navigation.toAirfal();
  }

  getStringTime(date: Date) {
    let calendar = date.toString().split("T");
    let time = calendar[0].split("-");
    return time[2] + "/" + time[1] + "/" + time[0];
  }

  getStringTimeHour(date: Date) {
    let day, month, hour, minute;
    if (date.getDate().toString().length == 1) {
      day = "0" + date.getDate();
    } else {
      day = date.getDate();
    }
    if ((date.getMonth() + 1).toString().length == 1) {
      month = "0" + (date.getMonth() + 1);
    } else {
      month = (date.getMonth() + 1);
    }
    if (date.getHours().toString().length == 1) {
      hour = "0" + date.getHours();
    } else {
      hour = date.getHours();
    }
    if (date.getMinutes().toString().length == 1) {
      minute = "0" + date.getMinutes();
    } else {
      minute = date.getMinutes();
    }
    return day + "/" + month + "/" + date.getUTCFullYear() + " " + hour + ":" + minute;
  }

  newMensaje() {
    let mensaje: contactoMensaje = {
      idContactoMensaje: "ID",
      idContacto: this.contacto.idContacto,
      idUsuario: this.user.getId(),
      nombreUsuario: "",
      date: new Date(),
      mensaje: this.mensaje
    }
    this.contactMessageService.new(mensaje).subscribe(result => {
      console.log(result);
      this.getContactosMensajes();
    });
  }

  closeContacto() {
    this.contactService.closeContacto(this.contacto.idContacto).subscribe(result => {
      this.toAirfal();
    });
  }

  changeExpand() {
    this.expand = !this.expand;
  }

}
